import { SimpleChanges } from '@angular/core';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Indirizzo } from '../../models/portale/indirizzo';

@Component({
	selector: 'lib-dati-residenza',
	templateUrl: './dati-residenza.component.html',
	styleUrls: ['./dati-residenza.component.css']
})
export class DatiResidenzaComponent implements OnInit {

	form: FormGroup;

	@Input() residenza$: Observable<Indirizzo>;

	indirizzoToltip = "INDIRIZZO";
	civicoToltip = "civico";
	nazioneToltip = "nazione";
	provinciaToltip = "provincia";
	regioneToltip = "regione";
	comuneToltip = "comune";
	capToltip = "cap";

	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {}

	ngOnInit(): void {
		this.form = new FormGroup({});
	}

}
